module.exports = __webpack_public_path__ + "static/shh-logo-1a6e7a283683981e42cf7163cebb08f6.png";